var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-wizard-form-field" },
    [
      _vm.field.type === "select"
        ? _c("AutomationWizardFieldSelect", {
            attrs: { field: _vm.field, value: _vm.value },
            on: { "update:value": _vm.handleUpdateValue }
          })
        : _vm.field.type === "pipeline_step_opp"
        ? _c("AutomationWizardFieldPipelineStepOpp", {
            attrs: {
              field: _vm.field,
              value: _vm.value,
              formData: _vm.formData
            },
            on: { "update:value": _vm.handleUpdateValue }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }